<div class="card-title mb-4" i18n>Supporting Documents</div>

<div class="d-flex flex-column" [style.gap.rem]="2">
  <!-- Submitted Files -->
  <ng-container *ngIf="filesUploadedDuringSubmission?.length || logo?.attachment; else submittedFilesEmptyState">
    <div class="d-flex flex-column gap-3">
      <div class="section-title" i18n>Submitted Files</div>
      <div class="d-flex flex-column">
        <app-file-list-item
          *ngFor="let file of filesUploadedDuringSubmission; trackBy: submissionAttachmentTrackBy"
          [fileName]="file.attachment.fileName"
          [fileSizeInBytes]="file.attachment.fileSize"
          [previewUrl]="getPreviewUrl(file)"
          [thumbnailUrl]="getThumbnailUrl(file)"
          action="download"
          (downloadClicked)="onDownloadFile(file)" />
        <app-file-list-item
          *ngIf="logo?.attachment"
          [fileName]="logo?.attachment?.fileName ?? ''"
          [previewUrl]="getLogoPreviewUrl()"
          [thumbnailUrl]="getLogoThumbnailUrl()"
          [disabled]="!getLogoPreviewUrl()"
          action="download"
          (downloadClicked)="onDownloadLogo()" />
      </div>
    </div>
  </ng-container>
  <ng-template #submittedFilesEmptyState>
    <div class="d-flex flex-column gap-3">
      <div class="section-title" i18n>Submitted Files</div>
      <div class="section-description" i18n>No submitted files.</div>
    </div>
  </ng-template>

  <!-- Additional Files -->
  <div class="d-flex flex-column" [class.gap-3]="canUploadFiles || additionalFiles?.length">
    <div class="d-flex flex-column gap-3">
      <div class="section-title" i18n>Additional Files</div>
      <div *ngIf="canUploadFiles" class="section-description" i18n>
        Add supporting documentation for this submission.
      </div>
      <div *ngIf="!canUploadFiles && !additionalFiles?.length" class="section-description" i18n>
        No additional files.
      </div>
    </div>
    <ng-container *ngIf="canUploadFiles" [formGroup]="formGroup">
      <app-file-upload-field
        formControlName="file"
        [control]="formGroup.controls.file"
        [inputName]="'file'"
        [multiple]="true"
        [hideFileList]="true"
        [accept]="['image/png', 'image/jpeg', 'application/pdf']"
        [maxFileSizeInMb]="3">
        <ng-container input-copy>
          <img height="24" [src]="'assets/icons/blue/UploadFile.svg'" alt="Upload File" i18n-alt />
          <app-file-uploader-text
            instructionText="Upload a file or drag and drop a .png, .jpeg, or .pdf"
            i18n-instructionText
            descriptionText="Up to 3 MB"
            i18n-descriptionText />
        </ng-container>
      </app-file-upload-field>
    </ng-container>
    <div *ngIf="additionalFiles?.length" class="d-flex flex-column mt-2">
      <app-file-list-item
        *ngFor="let file of additionalFiles; trackBy: submissionAttachmentTrackBy"
        [fileName]="file.attachment.fileName"
        [fileSizeInBytes]="file.attachment.fileSize"
        [previewUrl]="getPreviewUrl(file)"
        [action]="submissionApproved ? 'download' : 'remove'"
        (previewClicked)="onPreviewFile(file)"
        (downloadClicked)="onDownloadFile(file)"
        (removeClicked)="removeFile.emit(file)" />
    </div>
  </div>
</div>
